import axios from 'axios';
import { removeScheduleItemsQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import Split from '../split';

const removeScheduleItems = async (ids) => {
    try {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpress ? buildExpressQuery : buildLoopbackQuery;
        const query = removeScheduleItemsQuery({ ids, queryBuilder });
        const request = axios.patch(query.url, { ...query.body });
        const { data } = await request;
        return { ids: data };
    } catch {
        throw new Error('Unable to remove schedule items');
    }
};

export default removeScheduleItems;
